<mydocma-stepper [class.mydocma-mm-wt-steppert-mobile]="mobileMode"
  style="width: 100%;"
  [stepperConfig]="stepperConfig"
  [stepperOptions]="stepperOptions"
  (ready)="onReadyEvent($event)">
  <ng-template mydocmaStep="selectTemplate" let-step="step">
    <mydocma-mm-report-template-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-report-template-step>
  </ng-template>
  <ng-template mydocmaStep="selectOptions" let-step="step">
    <mydocma-mm-report-options-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-report-options-step>
  </ng-template>
  <ng-template mydocmaStep="selectCreationType" let-step="step">
    <mydocma-mm-report-create-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-report-create-step>
  </ng-template>
  <ng-template mydocmaStep="selectEmail" let-step="step">
    <mydocma-mm-report-email-step mydocmaStepComponent [reportConfig]="reportConfig" [step]="step">
    </mydocma-mm-report-email-step>
  </ng-template>
</mydocma-stepper>
